import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";
import { Product } from "../types/product";
import { Function } from "../types/function";

// Tạo API service với createApi
export const functionApi = createApi({
  reducerPath: "functionApi",
    baseQuery: baseQueryWithReauth,
  // baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  tagTypes: ["function"],
  endpoints: (builder) => ({
    getFunctionByProductId: builder.query<Function[], { productId: string }>({
      query: ({ productId }) => `function/get-function-by-productid/${productId}`,
      providesTags: (result?: Function[]) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "function" as const, _id })),
              { type: "function", _id: "LIST" },
            ]
          : [{ type: "function", _id: "LIST" }],
    }),
    createOrUpdateFunction: builder.mutation({
        query: (user) => ({
          url: "function/create-or-update",
          method: "POST",
          body: user,
        }),
        invalidatesTags: ["function"],
      }),
    deleteFunctionById: builder.mutation({
      query: (id) => ({
        url: `function/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['function'],
    }),
    searchFunction: builder.query<Function[], {
      product_id?: string;
      function_name?: string;
      function_type?: string;
      indentifier?: string;
      data_type?: string;
      data_transfer_type?: string;
    }>({
      query: (params) => ({
        url: "function/search",
        method: "POST",
        body: params,
      }),
      providesTags: (result?: Function[]) =>
        result
          ? [
            ...result.map(({ dp_id }) => ({ type: "function" as const, id: dp_id })),
            { type: "function", id: "LIST" },
          ]
          : [{ type: "function", id: "LIST" }],
    }),
  }),
});

// Export hooks để sử dụng trong component
export const {
    useGetFunctionByProductIdQuery,
    useCreateOrUpdateFunctionMutation,
    useDeleteFunctionByIdMutation,
    useSearchFunctionQuery
} = functionApi;
